<template>
  <v-flex>
      <div ref="content">
      <v-card v-if="!justPlot">
          <v-hover>
          <v-card-text slot-scope="{ hover }" class="caption grey--text">
              <v-layout style="min-height:40px;">
                  <loading-progress-bar :loading="loading" color="secondary"></loading-progress-bar>
                  <v-spacer></v-spacer>
                  <v-fade-transition>
                  <span v-show="(!loading && hover)" ma-0 pa-0>
                      <v-btn @click="downloadWithCSS" outline small flat round class="grey--text" ma-0 pa-0>
                          <!-- TODO Fine tune download pdf -->
                          Export as PDF
                      </v-btn>
                  </span>
                  </v-fade-transition>
                  <span>{{facility_name}} </span>
              </v-layout>
          </v-card-text>
          </v-hover>
          <v-card-text v-if="type==='dygraph'">
              <dygraphs-component :df="df" ref="dygraphplot"></dygraphs-component>
          </v-card-text>
          <v-card-text v-else>
              <vue-plotly v-if="!loading" :data="data" :disable-responsive="disableResponsive" :layout="layout" :options="options" ref="plotly"/>
          </v-card-text>
      </v-card>
          <vue-plotly v-if="justPlot&&!loading" show-export :data="data" :disable-responsive="disableResponsive" :layout="layout" :options="options" ref="plotly"/>
      </div>
  </v-flex>
</template>

<script>
import VuePlotly from './VuePlotly'
import {getTimeSeries} from '@/helper'
import DygraphsComponent from './DygraphsComponent'
import LoadingProgressBar from './LoadingProgressBar'
import jsPDF from 'jspdf'
import {exportCSVFromDicts} from "@/tocsv.js"

export default {
  props: {
    title: {type: String, default: ''},
    variablesList: {type: Array, default: null},
    variableX: {type: String, default: 'timestamp'},
    dateRange: {type: Object, default: null},
    layoutOverrides: {type: Object, default: null},
      equipmentName: {type: String, default: 'Chiller 1'},
    type: {type: String, default: 'scattergl'},
    onOnly: {type:Boolean, default: false},
      justPlot:{type:Boolean,default:false},
      disableResponsive:{type:Boolean,default:false}
  },
  components: {
    LoadingProgressBar,
    DygraphsComponent,
    VuePlotly
  },
  computed: {
    layout(){
        let settings={
            title: this.title,
            hovermode: 'closest',
            xaxis: {
                title: this.variableX
            },
            yaxis: {
                title: this.variableY
            }
        };
        if(this.layoutOverrides){
            settings=Object.assign({}, settings, this.layoutOverrides);
        }
      return settings;
    }
  },
  name: 'MultiPlotChart',
  watch: {
    variablesList () {
      this.refresh()
    },
    dateRange () {
      this.refresh()
    },
      equipmentName() {
          this.refresh()
      },
    onOnly () {
      this.refresh()
    }
  },
  data: function () {
    return {
      data:[],
      timeout:null,
      facility_name:null,
      options: {},
      df: null,
      loading: true
    }
    },
  methods: {
    downloadCSV () {
      exportCSVFromDicts(this.df)
    },
    download() {
      const doc = new jsPDF();
      const contentHtml = this.$refs.content.innerHTML;

      doc.fromHTML(contentHtml, 15, 15, {
        width: 170
      });
      doc.save("export.pdf");
    },
     async downloadWithCSS() {
       //const doc = new jsPDF();
       var doc = new jsPDF('', 'pt', 'a4');

       /** WITH CSS */
       let img = null
       if(this.type==='dygraph'){
         img = this.$refs.dygraphplot.toImage()
         doc.addImage(img, 'JPEG', 0, 0,
           1.0*595.28,
           1.0*595.28/this.$refs.dygraphplot.$refs.graphdiv.clientWidth*this.$refs.dygraphplot.$refs.graphdiv.clientHeight)
       } else {
         img =  await this.$refs.plotly.toImage()
         doc.addImage(img, 'JPEG', 0, 0,
           1.0*595.28,
           1.0*592.28/this.$refs.plotly.$refs.container.clientWidth*this.$refs.plotly.$refs.container.clientHeight
         )
       }

        doc.save("export.pdf")

     },
      debounce(callback, wait) {
          clearTimeout(this.timeout);
          this.timeout= setTimeout(() => callback(), wait);
      },
      refresh(){
          this.debounce(this.doRefresh,200);
      },
      doRefresh() {
        let me=this;
      this.loading=true
      if (!!this.variablesList && !!this.facility_name){
        this.data = []
          let promises=[];
        for (let i in this.variablesList) {


            let equipment_name = this.variablesList[i].equipment_name ? this.variablesList[i].equipment_name : this.equipmentName
            let varsArray = [this.variablesList[i].name]
            if (this.variablesList[i].variableX) {
                varsArray.unshift(this.variablesList[i].variableX);
            }
            let agg=this.variablesList[i].agg ? this.variablesList[i].agg : null;
            let apiBaseUrl=this.variablesList[i].apiBaseUrl ? this.variablesList[i].apiBaseUrl : null;
            let facilityName=this.variablesList[i].facility_name ? this.variablesList[i].facility_name : this.facility_name;
            promises.push(getTimeSeries(
                varsArray,
                equipment_name,
                facilityName,
                this.dateRange,
                agg,
                this.onOnly || this.variablesList[i].on_only,
                null,
                false,
                apiBaseUrl
            ));
        }
            Promise.all(promises).then(function(reses) {
                let newData=[];
                let customXVariable=null;
                for (let i in me.variablesList) {
                    let df=reses[i];
                    if(me.variablesList[i].useAsXVariable){
                        customXVariable=df[me.variablesList[i].name];
                    } else {
                        newData.push(
                            {
                                x: me.variablesList[i].variableX ? df[me.variablesList[i].variableX] : customXVariable ? customXVariable : df[me.variableX],
                                y: df[me.variablesList[i].name],
                                type: me.type,
                                mode: me.variablesList[i].mode ? me.variablesList[i].mode : 'lines',
                                opacity:me.variablesList[i].opacity ? me.variablesList[i].opacity : 1.0,
                                name: me.variablesList[i].equipment_name? me.variablesList[i].equipment_name +' - ' + me.variablesList[i].name : me.equipmentName +' - ' + me.variablesList[i].name,
                                xbins:me.variablesList[i].xbins ? me.variablesList[i].xbins : {},
                                ybins:me.variablesList[i].ybins ? me.variablesList[i].ybins : {},
                                hovertext:me.variablesList[i].useXAsHover ? df[me.variableX] : null,
                                stackgroup:me.variablesList[i].stackgroup ? me.variablesList[i].stackgroup : null,
                                yaxis:me.variablesList[i].yaxis ? me.variablesList[i].yaxis : null,
                                line:me.variablesList[i].line ? me.variablesList[i].line : {},
                            }
                        )
                    }

                }
                newData.sort((a, b) => (a.name > b.name) ? 1 : -1)
                me.data=newData;
                me.loading=false;
            });
      } else {
          this.loading=false
      }

    }
  },
   mounted () {
      this.facility_name = this.$store.state.pointsListStore.pointsList.facility_name
      this.refresh()
  }
}

</script>

<style scoped>

</style>
